import { forwardRef } from 'react';
import { Icon } from './icon';
import type { IconProps } from './icon';
import type { Ref } from 'react';
export const UserCircle = forwardRef(function UserCircle(props: IconProps, ref: Ref<SVGSVGElement>) {
  return (
    <Icon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5ZM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12Zm9.417 1.75a1.917 1.917 0 0 0-1.917 1.917c0 .322.261.583.583.583h5.334a.583.583 0 0 0 .583-.583 1.917 1.917 0 0 0-1.917-1.917h-2.666ZM7.25 15.667a3.417 3.417 0 0 1 3.417-3.417h2.666a3.417 3.417 0 0 1 3.417 3.417c0 1.15-.933 2.083-2.083 2.083H9.333a2.083 2.083 0 0 1-2.083-2.083ZM10.75 8a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM12 5.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Z"
        fill="currentColor"
      />
    </Icon>
  );
});
